// 0 - Rascunho
// 1 - Em análise
// 2 - Em Contratação
// 3 - Não Iniciado
// 4 - Vigente
// 5 - Encerrado
// 6 - Desativado

export const CONTRATO_STATUS_TODOS = -1;

export const CONTRATO_STATUS_EM_EDICAO = 0;
export const CONTRATO_STATUS_EM_ANALISE = 1;
export const CONTRATO_STATUS_AGUARDANDO_ASSINATURA = 2;
export const CONTRATO_STATUS_NAO_INICIADO = 3;
export const CONTRATO_STATUS_VIGENTE = 4;
export const CONTRATO_STATUS_ENCERRADO = 5;
export const CONTRATO_STATUS_DESATIVADO = 6;
export const CONTRATO_STATUS_ASSINADO = 7;
export const CONTRATO_STATUS_AGUARDANDO_EXTRATO = 8;
export const CONTRATO_STATUS_APROVADO = 9;
export const CONTRATO_STATUS_NEGADO = 10;

export const allContratoStatus = [
  CONTRATO_STATUS_EM_EDICAO,
  CONTRATO_STATUS_EM_ANALISE,
  CONTRATO_STATUS_AGUARDANDO_ASSINATURA,
  CONTRATO_STATUS_NAO_INICIADO,
  CONTRATO_STATUS_VIGENTE,
  CONTRATO_STATUS_ENCERRADO,
  CONTRATO_STATUS_DESATIVADO,
  CONTRATO_STATUS_AGUARDANDO_EXTRATO,
  CONTRATO_STATUS_APROVADO,
  CONTRATO_STATUS_NEGADO,
];

export const allContratoAssessoresStatus = [
  CONTRATO_STATUS_EM_EDICAO,
  CONTRATO_STATUS_EM_ANALISE,
  CONTRATO_STATUS_AGUARDANDO_ASSINATURA,
  CONTRATO_STATUS_NAO_INICIADO,
  CONTRATO_STATUS_VIGENTE,
  CONTRATO_STATUS_ENCERRADO,
  CONTRATO_STATUS_DESATIVADO,
];

export const allContratoEntePublicoStatus = [
  CONTRATO_STATUS_EM_EDICAO,
  CONTRATO_STATUS_EM_ANALISE,
  CONTRATO_STATUS_AGUARDANDO_ASSINATURA,
  CONTRATO_STATUS_NAO_INICIADO,
  CONTRATO_STATUS_VIGENTE,
  CONTRATO_STATUS_ENCERRADO,
  CONTRATO_STATUS_DESATIVADO,
  CONTRATO_STATUS_AGUARDANDO_EXTRATO,
  CONTRATO_STATUS_APROVADO,
  CONTRATO_STATUS_NEGADO,
];

export const allContratoEntePrivadoStatus = [
  CONTRATO_STATUS_EM_EDICAO,
  CONTRATO_STATUS_EM_ANALISE,
  CONTRATO_STATUS_AGUARDANDO_ASSINATURA,
  CONTRATO_STATUS_NAO_INICIADO,
  CONTRATO_STATUS_VIGENTE,
  CONTRATO_STATUS_ENCERRADO,
  CONTRATO_STATUS_DESATIVADO,
];
